import { List, Record } from 'immutable';
const ArticleVideosRecord = Record({
  error: undefined,
  isRequesting: false,
  lastLoaded: null,
  // @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
  videos: new List()
});
export default ArticleVideosRecord;